<template>
  <div class="main">
    <!-- channel banner -->
    <div class="cbanner">
      <img src="../../assets/images/banner_list.jpg" />
      <div class="btext">
        <h3>借贷大厅</h3>
        <p>最低投资成本，最好的安全保证，专业互联网借贷信息中介平台</p>
      </div>
    </div><!-- channel banner END-->
    <div class="main_inner">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="btitle">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>借贷大厅</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/borrowProject' }">借入项目</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- business detail -->
      <el-row>
        <el-col :span="18" class="b_detail">
          <div class="business_detail">
            <h3 class="title_bdetail">
              {{form.projectName}}：{{form.projectCode}}
              <el-button type="primary" @click="checkUnprocessedIntention" v-if="form.realTimeStatus === 0">项目详情</el-button>
              <el-button type="primary" disabled v-else-if="form.realTimeStatus === 1">已完成</el-button>
              <el-button type="primary" disabled v-else="form.realTimeStatus === 2">已过期</el-button>
            </h3>
            <el-row class="bd_head_data">
              <el-col :span="8">
                <span class="color_red">{{form.yieldRate}}<sub>%</sub></span>预期收益率
              </el-col>
              <el-col :span="8">
                <span>{{form.amount}}<sub>元</sub></span>借款金额
              </el-col>
              <el-col :span="8">
                <span>{{form.deadline}}<sub>天</sub></span>借款期限
              </el-col>
            </el-row>

            <el-row class="bd_desc">
              <el-col :span="12">
                起投额度：{{form.firstAmount}}元<br />
                借款主体：{{form.borrowMain}}<br />
                发布日期：{{form.publishTime}}<br />
              </el-col>
              <el-col :span="12">
                还款方式：{{form.repaymentMethod}}<br />
                资金用途：{{form.purpose}}<br />
                保证方式：{{form.guaranteeMethod}}<br />
              </el-col>
            </el-row>
          </div>

          <el-row class="bd_ad">
            <el-col :span="8">
              <div class="qrcode">
                <img :src="this.form.quickMark" />
                <h5>
                  扫一扫分享
                  <p>微信扫码分享好项目给亲朋好友</p>
                </h5>
              </div>
            </el-col>
            <el-col :span="16" class="ad">
              <!-- 项目广告图-->
              <img :src="downloadFileURL+projectDetailBannerImage.imageUrl+'/'" />
            </el-col>
          </el-row>

          <div class="db_desc_more">
            <template>
              <el-tabs type="border-card" value="first">
                <el-tab-pane label="项目简介" name="first">
                  <div v-html="form.projectDescription" class="tab_con">
                  </div>
                </el-tab-pane>
                <el-tab-pane label="项目资料" name="second">
                  <div class="tab_con">

                    <el-row id="projectImg" :gutter="12">
                      <el-col v-for="img in files" :span="8" :key="img.id">
                        <el-card shadow="hover">
                          <img :id="img.id" :src="downloadFileURL+img.url+'/'" @click="showImg()">
                        </el-card>
                      </el-col>
                    </el-row>

                  </div>
                </el-tab-pane>
                <el-tab-pane label="出借记录" name="third">
                  <div class="tab_con">
                    <el-table :data="intentions" highlight-current-row style="width: 100%;" border>
                      <el-table-column prop="username" label="出借人" align="center"></el-table-column>
                      <el-table-column prop="phoneNumber" label="联系方式" align="center"></el-table-column>
                      <el-table-column prop="contractAmount" label="出借金额(元)" align="center"></el-table-column>
                      <el-table-column prop="transDate" label="出借日期" align="center" :formatter="formatDate"></el-table-column>
                    </el-table>
                    <el-pagination
                      background
                      @current-change="handleCurrentChange"
                      :page-size="pageSize"
                      layout="prev, pager, next"
                      :total="total">
                    </el-pagination>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </template>
          </div>

        </el-col>
        <el-col :span="6" class="b_side">
          <!-- calculator END -->
          <div class="calculator">
              <h3 class="title_side">收益计算器</h3>
              <el-row :gutter="6">
                  <el-col :span="8">计息方式：</el-col>
                  <el-col :span="16">
                      <label>按月付息，到期还本</label>
                  </el-col>
              </el-row>
              <el-row :gutter="6">
                  <el-col :span="8">出借金额：</el-col>
                  <el-col :span="14">
                      <el-input v-model="loanAmount" placeholder="输入出借金额"></el-input>
                      <span id="loanAmountError" style="color: red"></span>
                  </el-col>
                  <el-col :span="2">
                      <span>元</span>
                  </el-col>
              </el-row>
              <el-row :gutter="6">
                  <el-col :span="8">借款利率：</el-col>
                  <el-col :span="14">
                      <el-input v-model="bRate" placeholder="输入借款利率"></el-input>
                      <span id="bRateError" style="color: red"></span>
                  </el-col>
                  <el-col :span="2">
                      <span>%</span>
                  </el-col>
              </el-row>
              <el-row :gutter="6">
                  <el-col :span="8">出借期限：</el-col>
                  <el-col :span="10">
                      <el-input v-model="loanPeriod" placeholder="输入出借期限"></el-input>
                      <span id="loanPeriodError" style="color: red"></span>
                  </el-col>
                  <el-col :span="6">
                      <el-select v-model="dataOrMouth" clearable placeholder="选择">
                        <el-option
                          v-for="item in dataOrMouthArray"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <span id="loanDataOrMouthError" style="color: red"></span>
                  </el-col>
              </el-row>
              <el-row :gutter="6" id="myresult" style="display: none">
                  <el-col :span="10">利息收益：</el-col>
                  <el-col :span="14">
                      <label id="interestIncome"></label>
                  </el-col>
              </el-row>
              <el-row class="btns_calcutator">
                  <el-col :span="12">
                      <el-button type="default" @click="clearMe">清空</el-button>
                  </el-col>
                  <el-col :span="12">
                      <el-button type="primary" @click="calculate">计算</el-button>
                  </el-col>
              </el-row>
          </div>
          <!-- calculator END -->

          <!-- big btns -->
          <div class="bs_big_btns">
            <!--<a><i class="iconfont">&#xe725;</i>投融资服务</a>-->
            <a @click="goLoanProject"><i class="iconfont">&#xe725;</i>出借项目</a>
            <a @click="goAssignmentProject"><i class="iconfont">&#xe725;</i>债权转让</a>
            <a @click="goEcInvestment"><i class="iconfont">&#xe738;</i>股权/基金投资</a>
            <a @click="goDownload"><i class="iconfont">&#xe60c;</i>下载资料</a>
          </div><!-- big btns END -->

          <!-- cases END -->
          <div class="cases_side">
            <h3 class="title_side">项目成交案例<a @click="goCaseList">更多</a></h3>
            <div class="cs_list"  v-if="this.hotRCArray.length>0">
              <a v-for="hc in hotRCArray" @click="goRCDetail(hc.id)">
                <img :src="downloadFileURL+hc.imageUrl+'/'" />
                {{hc.title}}
              </a>
            </div>
          </div>
          <!-- cases END -->

        </el-col>
      </el-row>
      <!-- business detail END-->
    </div>
    <!-- 弹出层 -->
    <el-dialog width="640px" title="提示消息" :visible.sync="tipsVisible" top="36vh" center>
      <el-row>
        <el-col id="tmessage">
          温馨提示：确认了解该项目详细信息？
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipsVisible=false">取 消</el-button>
        <el-button type="primary" @click="sendIntention">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="640px" title="提示消息" :visible.sync="dialogMsgVisible" top="36vh" center>
      <el-row>
        <el-col>
          温馨提示：您的信息已成功发送。平台将会在24小时内与您联系，或者您还可以拨打客服热线400-029-7800直接了解项目信息。
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogMsgVisible=false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="640px" title="提示消息" :visible.sync="popupMsgVisible" top="36vh" center>
      <el-row>
        <el-col>
          温馨提示：当前项目您只能发送一次借贷意向，请勿重复操作。
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="popupMsgVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 弹出层约谈项目检验是否登录 -->
    <el-dialog width="640px" title="提示消息" :visible.sync="showLoginDialogMsg" top="36vh" center>
      <el-row>
        <el-col>
          温馨提示：您需要注册账户并登录成功后才能查看项目详情，会员可直接点击项目详情发送信息，平台将会在24小时内安排专人主动和您取得联系。或者您可以拨打服务热线 400 029 7800 获取项目详细信息。
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="goRegister">立即注册</el-button>
                <el-button @click="goLogin">直接登录</el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
  import util from '../../common/util'
  import  {reqWebUserOne} from "../../api/webUser-api"
  import {reqGetOneBorrowProject,reqGetCaseShowCount,reqValidateWebUser} from '../../api/projectManagement-api';
  import {reqGetDictionaryListByCode,reqGetDictionaryByIdList,reqGetOneByCode,reqGetAttachmentsByProjId,uploadFileURL,downloadFileURL,} from '../../api/system-api';
  import  {reqProjectDetailBannerImage} from '../../api/system-api'
  import {reqGetLoanIntentionByProjIdPage,reqLoanIntentionAdd,reqQueryUnprocessedIntention} from '../../api/intentionManagement-api';
  import {reqGetHotRC} from '../../api/contentManagement-api'
  import '../../common/viewer.min.css';
  import Viewer from '../../common/viewer.min';

  export default {
    data(){
      return{
        type:'',
        total:0,
        pageNum:1,
        pageSize:5,
        projectStatusArray:[],
        projectDetailBannerImage:{},
        form: {
          id:'',
          projectName:'',
          projectCode:'',
          projectCategory:'',
          amount:'',
          deadline:'',
          yieldRate:'',
          firstAmount:'',
          borrowMain:'',
          purpose:'',
          repaymentMethod:'',
          guaranteeMethod:'',
          projectDescription:'',
          attachmentIds:'',
          projectStatus:'',
          realTimeStatus:'',
          projectStatusCode:'',
          publishTime:'',
          quickMark:''
        },
        files:[],
        intentions:[],
        uploadFileURL: uploadFileURL,
        downloadFileURL: downloadFileURL,
        hotRCArray: [],
        tipsVisible:false,
        dialogMsgVisible:false,
        popupMsgVisible:false,
        showLoginDialogMsg:false,
        loanAmount:'',
        bRate:'',
        loanPeriod:'',
        dataOrMouth:'',
        dataOrMouthArray:[
          {value:'0',label:'天'},
          {value:'1',label:'月'},
        ],
      }
    },
    methods:{
      showImg(){
        $('#projectImg').viewer({
          movable:false
        });
      },
      checkIntegerAndDecimal(value){
        if (!value) {
          return -2;
        }
        var reg =/^\d+(\.\d{1,2})?$/;
        if (reg.test(value)) {
          return 1;
        } else {
          return -1;
        }
      },
      clearMe(){
        this.loanAmount = '';
        this.bRate = '';
        this.loanPeriod = '';
        this.dataOrMouth='';
        $('#loanAmountError').hide();
        $('#bRateError').hide();
        $('#loanPeriodError').hide();
        $('#myresult').hide();
        $('#loanDataOrMouthError').hide();
      },
      calculate(){
        var isInvalidate = false;
        var val = this.checkIntegerAndDecimal(this.loanAmount);
        if(val == -2){
          $('#loanAmountError').html('请输入出借金额');
          $('#loanAmountError').show();
          isInvalidate = true;
        }else if(val == -1){
          $('#loanAmountError').html('输入的出借金额不正确');
          $('#loanAmountError').show();
          isInvalidate = true;
        }else{
          $('#loanAmountError').hide();
          isInvalidate = false;
        }

        val = this.checkIntegerAndDecimal(this.bRate);
        if(val == -2){
          $('#bRateError').html('请输入借款利率');
          $('#bRateError').show();
          isInvalidate = true;
        }else if(val == -1){
          $('#bRateError').html('输入的借款利率不正确');
          $('#bRateError').show();
          isInvalidate = true;
        }else{
          $('#bRateError').hide();
          isInvalidate = false;
        }
        val = this.checkIntegerAndDecimal(this.loanPeriod);
        if(val == -2){
          $('#loanPeriodError').html('请输入借出期限');
          $('#loanPeriodError').show();
          isInvalidate = true;
        }else if(val == -1){
          $('#loanPeriodError').html('输入的借出期限不正确');
          $('#loanPeriodError').show();
          isInvalidate = true;
        }else{
          $('#loanPeriodError').hide();
          isInvalidate = false;
        }
        if(!this.dataOrMouth) {
          $('#loanDataOrMouthError').html('请选择');
          $('#loanDataOrMouthError').show();
          isInvalidate = true;
        }else{
          $('#loanDataOrMouthError').hide();
          isInvalidate = false;
        }
        if(isInvalidate){
          return false;
        }else{
          var result='';
          if(this.dataOrMouth=='0'){
            result=Math.round((this.loanAmount*this.bRate/100)/365*this.loanPeriod)
          }else if(this.dataOrMouth=='1'){
            result = Math.round((this.loanAmount*this.bRate/100)/12*this.loanPeriod);
          }
          $('#loanAmountError').hide();
          $('#bRateError').hide();
          $('#loanPeriodError').hide();
          $('#myresult').show();
          $('#interestIncome').html(result);
        }
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.currentPage = val;
        this.getIntentions(this.form.id);
      },

      checkUnprocessedIntention:function(){
        reqValidateWebUser({}).then((res) =>{
          if(res.data.code == 1){
            this.dialogMsgVisible = false;
            this.popupMsgVisible = false;
            this.tipsVisible = false;
            reqQueryUnprocessedIntention({projectId:this.form.id,authorization: window.sessionStorage.getItem('Authorization')}).then((res) => {
              if(res.data.code != 1){
                this.tipsVisible = true;
              }else {
                this.popupMsgVisible = true;
              }
            });
          } else{
            this.showLoginDialogMsg = true;
          }
        });
      },
      goRegister(){
        this.$router.push({name: 'register',query: {redirect: this.$router.currentRoute.fullPath}});
      },
      goLogin(){
        this.dialogProjectVisible=false;
        this.$router.push({path:'/login',query: {redirect: this.$router.currentRoute.fullPath}})
      },
      sendIntention:function(){
        this.dialogMsgVisible = false;
        this.popupMsgVisible = false;
        this.tipsVisible = false;
        let para = {
          projectId:this.form.id,
          authorization: window.sessionStorage.getItem('Authorization')
          // 新意向不设置disposeStatus，表示对接中
        };
        reqLoanIntentionAdd(para).then((res) => {
          if(res.data.code == 1){
            this.dialogMsgVisible = true;
          }else {
            this.$message({
              message: '提交失败',
              type: 'failed'
            });
          }
        });
      },
      getProjectByid:function (id) {
        var that=this;
        reqGetOneBorrowProject({id:id}).then((res)=>{
          that.form = Object.assign({}, res.data.data);
          if(that.form.quickMark){
            that.form.quickMark = that.downloadFileURL+that.form.quickMark+'/'
          }
          var publishTime=res.data.data.publishTime;
          var nowDate=new Date().getTime();
          var deadline=res.data.data.deadline*1000*60*60*24;
          if(publishTime+deadline-nowDate<0){
            this.form.realTimeStatus=2;
          }
          if(that.form.publishTime){
            that.form.publishTime=util.formatDate.format(new Date(that.form.publishTime),'yyyy-MM-dd')
          }
          reqGetDictionaryByIdList({ids: that.form.projectCategory}).then((res) => {
            var dictionarys = res.data.data;
            dictionarys.forEach(function (obj, i) {
              return that.form.projectCategory = obj.name;
            });
          });

          reqGetDictionaryByIdList({ids: that.form.borrowMain}).then((res) => {
            var dictionarys = res.data.data;
            dictionarys.forEach(function (obj, i) {
              return that.form.borrowMain = obj.name;
            });
          });

          reqGetDictionaryByIdList({ids: that.form.repaymentMethod}).then((res) => {
            var dictionarys = res.data.data;
            dictionarys.forEach(function (obj, i) {
              return that.form.repaymentMethod = obj.name;
            });
          });

          var gm = that.form.guaranteeMethod;
          if(gm != null && gm != '') {
            reqGetDictionaryByIdList({ids: gm}).then((res) => {
              var dictionarys = res.data.data;
              gm = '';
              dictionarys.forEach(function (obj, i) {
                gm += obj.name;
                if (i < (dictionarys.length - 1)){
                  gm += ', ';
                }
              });
              return that.form.guaranteeMethod = gm;
            });
          }
        })
      },
      getAttachments:function(id){
        var that=this;
        reqGetAttachmentsByProjId({id:id}).then((res) => {
          if(res.data.code===1){
            that.files = res.data.data;
          }
        });
      },
      getIntentions:function(id){
        var that=this;
        let para = {
          pageNum: that.pageNum,
          pageSize: that.pageSize,
          projectId: id,
          disposeStatus:0
        };
        reqGetLoanIntentionByProjIdPage(para).then((res) => {
          if(res.data.code===1){
            that.total = res.data.data.total;
            that.intentions = res.data.data.list;
          }
        });
      },
      goEcInvestment(){
        this.$router.push({name: 'ecInvestmentIntroduction'});
      },
      goLoanProject(){
        this.$router.push({name: 'loanProject'});
      },
      goAssignmentProject(){
        this.$router.push({name: 'assignmentDebt'});
      },
      goDownload(){
        this.$router.push({name: 'dataDownload'});
      },
      goCaseList(){
        this.$router.push({name: 'caseShow'});
      },
      goRCDetail(id){
        reqGetCaseShowCount().then(res=>{
          this.total=0;
          this.total=res.data.data;
          this.$router.push({name: 'caseShowDetail', query: {id: id,total:this.total}});
        });
      },
      goProjectList(){
        this.dialogMsgVisible = false;
      },
      getGetHotRC(){
        var that = this;
        reqGetOneByCode({code:'counseling_case_shows'}).then((res) =>{
          if(res.data.code == 1){
            let para = {
              publishType: res.data.data.id,
              orderField: 'publish_time',
              orderRule: 'desc',
              startIndex: 0,
              rowCounts: 3
            };
            reqGetHotRC(para).then((res) =>{
              that.hotRCArray = res.data.data;
            });
          }
        });
      },
      formatDate: function(row, column){
        if(row.transDate)
          return util.formatDate.format(new Date(row.transDate), 'yyyy-MM-dd');
      },

      getProjectDetailBannerImages(){
        reqProjectDetailBannerImage().then((res)=>{
          if(res.data.code===1){
            this.projectDetailBannerImage=res.data.data
          }else {
            this.projectDetailBannerImage={};
          }
        })
      },
      getType(){
        var id = window.sessionStorage.getItem('Authorization');
        reqWebUserOne({id:id}).then(res=>{
          this.type=res.data.data.type;
        })

      }
    },
    mounted(){
      var row=this.$route.query;
      this.$store.dispatch('showHF');
      this.getType();
      this.getProjectByid(row.id);
      this.getAttachments(row.id);
      this.getIntentions(row.id);
      this.getGetHotRC();
      this.getProjectDetailBannerImages();
    },
  }
</script>
<style slot-scope="scope">
  .viewer-close { background-color: rgba(244, 67, 54, .6); }
  .el-dialog__wrapper .el-dialog .el-dialog__body { line-height: 2; }
</style>



// WEBPACK FOOTER //
// src/components/projectManagement/BorrowProjectDetail.vue